class RegistrationForm {

  elements = {};

  constructor(wrapper) {
    this.loadElements(wrapper);
    this.setEvents();
    if(this.hasSubmittedSuccessfully()) {
      this.clearSubmissionRecord();
      this.showSuccess();
      this.open();
    }
    if(location.hash == '#' + this.elements.wrapper.attr('id')) {
        this.open();
    }
  }

  loadElements(wrapper) {
    this.elements.wrapper = wrapper;
    this.elements.closeButton = wrapper.find('.registration-form__close-button');
    this.elements.formWrapper = wrapper.find('.registration-form__form-wrapper');
    this.elements.form = wrapper.find('.registration-form__form');
    this.elements.success = wrapper.find('.registration-form__success');
  }

  open() {
    this.elements.wrapper.prop('hidden', false);
    location.hash = '#' + this.elements.wrapper.attr('id');
  }

  close() {
    this.elements.wrapper.prop('hidden', true);
    location.hash = '';
  }

  hasSubmittedSuccessfully() {
    const url = new URL(window.location.href);

    if(url.searchParams.get('contact_posted') != 'true') {
      return false;
    }

    return typeof Cookies.get('registration-form-submission') !== 'undefined';
  }

  recordSubmission() {
    Cookies.set('registration-form-submission', true);
  }

  clearSubmissionRecord() {
    Cookies.remove('registration-form-submission');
  }

  showSuccess() {
    this.elements.formWrapper.prop('hidden', true);
    this.elements.success.prop('hidden', false);
  }

  hideSuccess() {
    this.elements.formWrapper.prop('hidden', false);
    this.elements.success.prop('hidden', true);
  }

  setEvents() {
    jQuery(document).on(
      'registration-form:open',
      () => {
        this.clearSubmissionRecord();
        this.hideSuccess();
        this.open();
      }
    );
    window.addEventListener(
      'hashchange',
      (event) => {
        if(location.hash !== '#' + this.elements.wrapper.attr('id')) {
          return;
        }

        this.open();
      }
    );
    this.elements.wrapper.on(
      'click',
      (event) => {
        if(!this.elements.wrapper.is(event.target)) {
          return;
        }

        this.close();
      }
    );
    this.elements.closeButton.on(
      'click',
      () => {
        this.close();
      }
    );
    this.elements.form.on(
      'submit',
      (event) => {
        location.hash = '';
        this.recordSubmission();
      }
    );
  }
}

jQuery(document).ready(
  async () => {
    // Wait for dependencies to be loaded
    await new Promise(
      (resolve) => {
        const interval = setInterval(
          () => {
            if(typeof Cookies == 'undefined') {
              return;
            }

            clearInterval(interval);
            resolve();
          },
          50
        );
      }
    );

    const wrappers = jQuery('.registration-form__wrapper');
    wrappers.each(
      (index) => {
        new RegistrationForm(wrappers.eq(index));
      }
    );
  }
);
